import { useQuery } from '@tanstack/react-query';

import { medicalHubApi } from '../hub';

export const medicalHubKeys = {
  /**
   * Every day's board and every day's coverage list. A visit or a reading recorded from the hub
   * lands on one date, but the nurse may be looking at another — invalidating the prefix keeps
   * both honest.
   */
  todayAll: ['medical', 'hub', 'today'] as const,
  temperatureAll: ['medical', 'audit', 'temperature'] as const,
  today: (date: string) => ['medical', 'hub', 'today', date] as const,
  measurements: () => ['medical', 'audit', 'measurements'] as const,
  temperature: (date: string) => ['medical', 'audit', 'temperature', date] as const,
  allergies: () => ['medical', 'audit', 'allergies'] as const,
  growth: () => ['medical', 'audit', 'growth'] as const,
};

export function useMedicalTodayQuery(date: string) {
  return useQuery({ queryKey: medicalHubKeys.today(date), queryFn: () => medicalHubApi.today(date) });
}

export function useMeasurementAuditQuery() {
  return useQuery({ queryKey: medicalHubKeys.measurements(), queryFn: () => medicalHubApi.measurements() });
}

export function useTemperatureAuditQuery(date: string) {
  return useQuery({ queryKey: medicalHubKeys.temperature(date), queryFn: () => medicalHubApi.temperature(date) });
}

export function useAllergyAuditQuery() {
  return useQuery({ queryKey: medicalHubKeys.allergies(), queryFn: () => medicalHubApi.allergies() });
}

export function useGrowthAuditQuery() {
  return useQuery({ queryKey: medicalHubKeys.growth(), queryFn: () => medicalHubApi.growth() });
}
